import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

import { AiffListComponent } from './detail/aiff/list/aiff-list.component';

@Component({
  selector: 'app-tenant-application-list-page',
  standalone: true,
  imports: [AiffListComponent, TestIdDirective],
  template: ` <aiff-list [tenantId]="tenantId" pageTitleKey="tenant.detail.application-list" testId="tenant-application-list-page" /> `
})
export class TenantApplicationListPageComponent {
  private readonly route = inject(ActivatedRoute);

  readonly tenantId = this.route.snapshot.paramMap.get('tenantId') ?? '';
}
